<!-- 上传图片或excel文件 -->
<template>
    <div class="upload-img"
        :style="messageStyle"
        :class="{'hideCardBorder':drag}"
        >
        <el-upload
            :disabled="disabled"
            ref="imgUpload"
            :file-list="imgList"
            :action="action"
            :limit="limit"
            :drag="drag"
            :list-type="listTypeCom"
            :show-file-list="showFileList"
            :auto-upload="false"
            :on-preview="onPreview"
            :on-change="onChange"
            :on-exceed="onExceed"
            :on-remove="onRemove"
            :accept="!drag ? acceptType : '' "
            :multiple="multiple"
            :class="{ 
                'hideUpload': imgList.length === limit && acceptType === 'image',
                'isPdf': isShowBord
            }"
        >
            <slot>
                <i :class="iconClass"></i>
            </slot>
        </el-upload>

        <!-- 预览图片 -->
        <el-dialog :visible.sync="dialogVisible" @close="dialogImageUrl=''">
            <img width="100%" :src="dialogImageUrl" alt="" v-if="imgList.length === 1" />
            <div class="carousel" v-else>
                <div class="el-carousel__container" >
                    <el-button 
                        style="z-index: 999;" 
                        icon="el-icon-arrow-left" 
                        class="el-carousel__arrow el-carousel__arrow--left" 
                        @click="arrow('left')">
                    </el-button>
                    <el-button 
                        style="z-index: 999;" 
                        icon="el-icon-arrow-right" 
                        class="el-carousel__arrow el-carousel__arrow--right" 
                        @click="arrow('right')">
                    </el-button>
                    <div 
                        v-for="(item,index) in imgList" 
                        :key="index" 
                        :ref="index + 'img'"
                        class="el-carousel__item"
                        :style="{
                            'transform': `translateX(${arrIndex[index]}px) scale(1)`,
                            'text-align': 'center'
                        }">
                        <img :src="item.url"  alt="" class="carousel__img">
                    </div>
                </div>
                <!-- 底部指示器 -->
                <ul class="el-carousel__indicators el-carousel__indicators--horizontal">
                    <li v-for="item in imgList.length" class="el-carousel__indicator el-carousel__indicator--horizontal" @click="clickIndex(item -1)">
                        <div class="el-carousel__button" :class="{ 'isActive':isActive === item }"></div>
                    </li>
                </ul>
            </div>
        </el-dialog>

        <!-- 重塑图片尺寸 -->
        <el-dialog :visible.sync="dialogVisible2"  :show-close="false">
            <div class="tailor">
                <div class="tipTop">
                    <div class="title">请确认绘制后的图片</div>
                    <el-tag size="medium" type="danger" class="tip">图片的尺寸大小应为{{messageInfo}}，需要重新绘制</el-tag>
                </div>

                <!-- 预览图 -->
                <canvas id="resizedCanvas" class="tailorImg"></canvas>
            </div>
            <div class="footer">
                <el-button @click="closeDialogIsTailor">取 消</el-button>
                <el-button type="primary" @click="sureImg">确 定</el-button>
            </div>
        </el-dialog>
    </div>
    
</template>
<!-- show-file-list -->
<script>
import Compressor from 'compressorjs'
import { getQiNiuToken } from '@/apis/qiniu.js'
import $ajax from 'axios'
import { importExcel2 } from "@/tools/excel.js";
import { hideLoad } from '@/tools/loading.js'
import { base64ToFile } from '@/tools/base64'
import Sortable from 'sortablejs';
// import {md5} from '@/tools/md5'
// auto-upload
export default {
    name:'jxUploadFile',
    props: {
        value: {             // v-model绑定的值
            type: [String,Array],
            // default:"https://image.jxc4.com/image/770693d0641d7794632e9832f8500838.png"
        },
        width: {             // 拖拽范围的宽度
            type: Number,
            default:148
        },
        height: {            // 拖拽范围的高度
            type: Number,
            default:148
        },
        action: {
            type: String,
            default:"http://up-z2.qiniup.com/"
        },
        limit: {
            type: Number,
            default:1
        },
        drag: {             // 拖拽
            type: Boolean,
            default:false
        },
        multiple: {        // 是否支持多选
            type: Boolean,
            default:false
        },
        showFileList: {     // 是否显示已上传文件列表
            type:Boolean,
            default:true
        },
        listType: {
            type: String,
            // default:"picture-card"
            default:"text"
        },
        autoUpload: {   //是否在选取文件后立即进行上传
            type: Boolean,
            default:false            
        },
        acceptType: {
            type: String,
            default:"image"
        },
        iconClass: {
            type: String,
            default:"el-icon-plus"
        },
        imgSize: {             // 图片的内存大小
            type: Number,
            default:-1
        },
        isTmp: {
            type: Boolean,
            default:false
        },
        imgType: {
            type: Array,
            default:() => ["image/jpeg","image/png"]
        },
        imgWidth: {         // 图片的宽度
            type: Number,
            default:-1
        },
        imgHeight: {        // 图片的高度
            type: Number,
            default:-1
        },
        isUseMd5: {      // 是否使用MD5加密
            type: Boolean,
            default:false
        },
        isUrl: {
            type: Array,
            default:() => []
        },
        name:{
            type: String,
            default:''
        },
        disabled:{
            type:Boolean,
            default:false
        },
        isGetBase64:{
            type:Boolean,
            default:false
        }
    },
    data() {
        return {
            updateImgFile: "",
            localDomain: "https://image.jxc4.com/",  // 用来拼接图片地址
            // imgUrlarr: [],
            dialogVisible: false,       // 预览图片开关
            dialogImageUrl: "",         // 预览图片的地址
            imgList: [],
            importData: [],             // excel导出的数据
            hideUploadCard: false,
            imgMd5: '',                 // md5 加密后的数据      
            dialogVisible2:false,       // 重塑图片dialog
            tailorContent:{},           // 重塑图片数据   
            initialIndex:0,             // 初始状态激活的幻灯片的索引     
            arrIndex:[0,977,1954,-1954,-977],
            isActive:1,                  // 默认第一张图片
            isShowBord:'',
            isGetValue:true              // 是否改变v-model的值
        }
    },
    created() {
        if (this.isUrl.length > 0 && !this.value) {
            this.arrIndex = []
            this.isUrl.map((item,index) => {
                if (item) {
                    this.imgList.push({
                        name: 'current&' + index,
                        url:item
                    })
                    this.arrIndex.push(index * 977)
                }
            })
        }  
    },
    watch:{
        value: {
            handler(val) {
                if (val && val.length > 0  && this.acceptType === 'image') {
                     if(!this.isGetValue) return this.isGetValue = true
                    if(Array.isArray(val)){
                        this.arrIndex = []
                        this.imgList = []
                        val.map((item,index) => {
                            if (item) this.imgList.push({ name: 'current&' + index, url: item })
                            this.arrIndex.push(index * 977)
                        })
                    }else this.imgList = [{ name: 'current&' + 0, url: val }]
                    this.initDragSort();
                } else this.imgList = []
            },
            immediate:true  
        },
        // 解析excel文件内容
        importData: function (to) {
            if (to && to.length > 0) {
                this.$emit("input",to)
                this.$emit("onChange", to)
            }
        },
        // // 默认的图片数组改变
        // isUrl:{
        //     handler(val){
        //         if(val && val.length){
        //             val.map((item,index) => {
        //                 let findIndex = this.imgList.findIndex(i => i.url === item)
        //                 if (item && findIndex === -1) {
        //                     this.imgList.push({
        //                         name: 'current&' + index,
        //                         url:item
        //                     })
        //                     this.imgUrlarr.push({
        //                         file: {
        //                             name:'current&' + index,
        //                         },
        //                         url:item
        //                     })
        //                 }
        //             })
        //         }
        //     }
        // }
    },
    computed: {
        messageStyle() {
            return {
                '--width': this.width + 'px',
                '--height':this.height + 'px',
                // '--display':this.isShowBord,
            }
        },
        messageInfo(){
            return this.imgHeight !== -1 && this.imgWidth !== -1 ? this.imgWidth + '*' + this.imgHeight
            : (this.imgWidth !== -1 && this.imgHeight === -1 ? '宽度为' + this.imgWidth
                : (this.imgWidth === -1 && this.imgHeight !== -1 ? "高度为" + this.imgHeight : '')
            )
        },
        listTypeCom(){
            if(this.updateImgFile && JSON.stringify(this.updateImgFile)!== '{}'){
                    let type= this.getFileType(this.updateImgFile)
                    this.isShowBord = type === 'pdf' ? 'none' : ''
                   return type === 'pdf' ? 'text' : this.listType
            }else{
                this.isShowBord =  ''
                return this.listType
            }
        }
    },
    mounted(){
        this.initDragSort();
    },
    methods: {
        clickIndex(findIndex){
            this.arrIndex = this.arrIndex.filter(item => item !== 0)             // 切换图片
            this.arrIndex = this.arrIndex.splice(0,findIndex).concat([0]).concat(this.arrIndex)
            this.isActive = findIndex + 1
        },
        arrow(type){
            if(type === 'left'){
                let temp = this.arrIndex.splice(0,1)
                this.arrIndex = this.arrIndex.concat(temp)
            }else {
                let temp = this.arrIndex.splice(this.imgList.length -1,1)
                this.arrIndex = temp.concat(this.arrIndex)
            }
            this.isActive = this.arrIndex.findIndex(item => item === 0) + 1
        },
        // 初始化图片列表拖拽
        initDragSort(){
            // if(this.imgUrlarr.length <= 1) return
            if(this.imgList.length <= 1) return
            this.$nextTick(() => {
                const el = this.$refs['imgUpload'].$el.querySelectorAll('.el-upload-list')[0];
                Sortable.create(el, {
                    onEnd: ({ oldIndex, newIndex }) => {
                        swapArrayElements(this.imgList,oldIndex,newIndex)
                        this.$emit('onChange',this.imgList)
                        
                        // 交换位置
                        function swapArrayElements(arr, indexA, indexB) {
                            const temp = arr[indexA];
                            arr.splice(indexA, 1);
                            arr.splice(indexB, 0, temp);
                        }
                    }
                });
            })
        },
        // 重塑图片尺寸
        remodelingImg(img,file) {
           
           this.$nextTick(()=>{
               const canvas = document.getElementById('resizedCanvas');
               const ctx = canvas.getContext('2d');
               
               // 设置canvas的宽度和高度
               canvas.width = this.imgWidth  !== -1 ? this.imgWidth : img.width; // 新宽度
               canvas.height = this.imgHeight !== -1 ? this.imgHeight : img.height; // 新高度
               
               // 绘制图片到canvas上
               ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

               // 将canvas的内容转换回图片
               const resizedImg = canvas.toDataURL(file.raw.type, 1); // 第二个参数是图片质量
               
               const fileName = file.name; // 文件的名字

               const newFile = base64ToFile(resizedImg, fileName); // base64 转 file

               this.tailorContent['tailorImg'] = {raw:newFile,size:newFile.size}
       
               // 显示修改后的图片
               // document.getElementById('resizedCanvas').style.display = 'block';

           })
       },
       // 重塑图片 确认
        sureImg(){
           this.onChange(this.tailorContent.tailorImg)   // 上传图片
        },
        // 重塑图片 取消
        closeDialogIsTailor(){
            this.imgList = [...this.imgList]
            this.tailorContent = {}
            this.dialogVisible2 = false
        },
        // 预览 关闭
        closeDialog(){
            this.dialogImageUrl = ''
            this.dialogVisible = false
        },
        // 预览 确认
        onPreview(e) {
            this.dialogImageUrl = e.url
            if(this.imgList.length > 1) {
                let findIndex = this.imgList.findIndex(item => item.name === e.name)
                if(findIndex !== 0){
                    this.arrIndex = this.arrIndex.filter(item => item !== 0)
                    this.arrIndex = this.arrIndex.splice(0,findIndex).concat([0]).concat(this.arrIndex)
                }else this.arrIndex = [0,977,1954,-1954,-977]  
                this.isActive = findIndex + 1
            }
            this.dialogVisible = true
        },
        onChange(file, fileList) {
            // console.log('上传文件的信息',file,'fileList',fileList)
            // return
            if (this.acceptType === '.xlsx') {
                importExcel2(this, file.raw, "importData") // 解析excel数据
                // this.$emit("onChange", file)
            } else if (this.acceptType === 'image') {
                this.uploadImgFun(file, fileList)   // 上传图片
            }
            
        },
        // pdf转base64
        fileToBase64(file){
            console.log('file',file)
            var reader = new FileReader();
            let that = this
            reader.onloadend = function() {
                var base64Data = btoa(reader.result);
                that.imgUrl = file.url
                that.imgList.push({
                    name:'current&' + (that.imgList.length + 1),
                    url: that.imgUrl,
                    raw:file.raw
                })

                if(typeof that.value === 'string') that.$emit("input", file.url)
                let suffix = that.getFileType(file) // 文件后缀
                that.$emit("onChange", {
                    attContext:base64Data,
                    attType:'',
                    attExtName:suffix,
                    fileName:file.raw.name,
                    file
                })

            };
            reader.readAsBinaryString(file.raw);
        },
        // 上传图片
        uploadImgFun(file, fileList) {
            if (!this.autoUpload) {
                if (this.value) this.$emit("input", file)
                this.$emit("onChange", file, fileList)
            } else {
                // 上传图片
                let isImgType = this.imgType.filter(item => item === file.raw.type)
                
                if (isImgType.length === 0) {
                    // 格式错误
                    this.$message({
                        message: `请选择 ${JSON.stringify(this.imgType)}格式的图片进行上传`,
                        type: 'warning',
                        center: true,
                    })
                    this.imgList = [...this.imgList]
                    // this.$refs.imgUpload.clearFiles()
                } else {
                    // 尺寸大小
                    this.widthOrHeight(file, (res,img) => {
                        if (!res) {
                            this.dialogVisible2 = true   // 打开弹框
                            this.tailorContent = {
                                ...file,
                                imgWidth:img.width,
                                imgHeight:img.height
                            }
                            this.remodelingImg(img,file) // 重塑图片尺寸
                            // this.$refs.imgUpload.clearFiles()
                            return
                        }
                        // 上传图片
                        // 内存大小
                        const isLt2M = this.imgSize !== -1 ? file.size < this.imgSize * 1024 * 1024 : false  
                        if (!isLt2M && this.imgSize !== -1) {
                            // 压缩文件
                            this.$confirm(`您上传的图片大于${this.imgSize}M，即将进行压缩，是否继续`, '提示').then((res) => {
                                this.compressedPicture(file)
                            }).catch((err) => {
                                this.$message({
                                    message: `图片大小不能超过${this.imgSize}M`,
                                    type: 'warning',
                                    center: true,
                                })
                                this.imgList = [...this.imgList]
                                // this.$refs.imgUpload.clearFiles()
                            })
                        } else {
                            // 格式正确
                            this.updateImgFile = file

                            // 是否获取base64
                             if(this.isGetBase64)  return this.fileToBase64(file)

                            //  综合了该管理系统的图片上传功能，其中有一个md5的功能，没看出来有啥作用，先注释掉
                            // 保存md5
                            if (this.isUseMd5) {
                                md5(file.raw, res => {
                                    this.imgMd5 = res.toUpperCase()
                                    this.uploadImg()
                                })
                            }else this.uploadImg()

                        }
                   })

                }
            }
        },
        // 文件超出个数限制时的钩子
        onExceed() {
            if(this.acceptType !== 'image') return
            this.$message({
                message: `最多上传${this.limit}张`,
                type: 'warning',
                center: true,
            })
        },
        // 文件列表移除文件时的钩子
        onRemove(e) {
            this.isGetValue = false
            let findIndex = this.imgList.findIndex(item => item.name === e.name)
            if(findIndex !== -1) {
                this.imgList.splice(findIndex,1)
                this.$emit("onChange", this.imgList)
            }
            this.$emit("onRemove", e)
            if(!Array.isArray(this.value) && this.value) this.$emit("input", '')
            else if(Array.isArray(this.value)){
                let brr  = this.imgList.map(item => item.url)
                this.$emit("input", brr)
            }
            // let index = this.imgUrlarr.findIndex(item => item.file.name === e.name)
            // if (index !== -1) {
            //     this.$emit("onRemove", this.imgUrlarr[index])
            //     this.imgUrlarr.splice(index, 1)
            //     this.imgList.splice(index, 1)
            //     if (this.value) this.$emit("input", '')
            //     this.$emit("onChange", this.imgUrlarr)
            // } else {
            //     this.$emit("onRemove", e)
            // }
        },
        // 上传图片
        uploadImg(fnSuccess, fnFail) {
            let suffix =  this.getFileType(this.updateImgFile)  // 后缀 // 后缀
            if (this.isTmp) suffix = '.tem' + suffix    // 临时图片标志
            getQiNiuToken(suffix, this.imgMd5 ? this.imgMd5 : '', (res) => {
                let formData = new FormData()
                formData.append('token', res.token)
                formData.append('key', res.fileName)
                formData.append('file', this.updateImgFile.raw)
                $ajax
                .post(this.action, formData)
                .then(
                    (res) => {
                        // res.data
                        if(fnSuccess) fnSuccess(res.data)
                        else{
                            let data = res.data
                            this.imgUrl = this.localDomain + data.key
                            this.imgList.push({
                                name:'current&' + (this.imgList.length + 1),
                                url: this.imgUrl,
                                raw:this.updateImgFile.raw
                            })
                            // console.log(this.updateImgFile,'this.updateImgFile',this.imgList)
                            if(this.acceptType === 'image') this.isGetValue = false
                            if(typeof this.value === 'string') this.$emit("input", this.imgUrl)
                            else{
                                // v-model绑定的多个值
                                let brr  = this.imgList.map(item => item.url)
                                this.$emit("input", brr)
                            }
                            this.$emit("onChange", this.imgList)

                            if(this.dialogVisible2){
                                this.tailorContent = {}
                                this.dialogVisible2 = false // 关闭dialog
                            }

                            // md5加密后 注册图片 by this.$props.name
                            // if(this.name) this.registerSrc(this.imgMd5, this.localDomain + data.key, this.updateImgFile.raw.type, this.name || '') 
                        }
                        
                        hideLoad()
                    },
                    {
                        timeout: 40000,
                    }
                )
                .catch((err) => {
                    if(fnFail) fnFail(err.data)
                    else{
                        this.$message({
                            message: '图片上传失败,请重新尝试' + err.data,
                            type: 'warning',
                            center: true,
                        })
                        
                        if(this.dialogVisible2) this.closeDialogIsTailor()
                    }
                   

                    hideLoad()
                })
            })
        },
        // 压缩图片
        compressedPicture(file) {
            let that = this
            let img = new Image
            img.src = file.url
            img.onload = function (e) {
                const compressor = new Compressor(file.raw, {
                    maxWidth: img.width,
                    maxHeight: img.height,
                    quality: 0.5,   // 压缩比例
                    success(result) {
                        that.onChange({raw:result,size:result.size})
                    },
                    error(err) {
                        that.$message({
                            message: '图片压缩失败,请重新尝试' + err,
                            type: 'warning',
                            center: true,
                        })
                    }
                })
            }
        },
        // 图片宽高是否符合要求
        async widthOrHeight(file, fn) {
            // let that = this
            if (this.imgWidth !== -1 || this.imgHeight !== -1) {
                let reader = new FileReader()
                reader.readAsDataURL(file.raw)
                reader.onload = (e) => {
                    let img = new Image()
                    img.src = e.target.result
                    img.onload = () => {
                        let flag = true
                        if (this.imgWidth !== -1 && this.imgHeight !== -1) {
                            flag = this.imgWidth === img.width && this.imgHeight === img.height
                        } else if (this.imgWidth !== -1 && this.imgHeight === -1) {
                            flag = this.imgWidth === img.width
                        } else if (this.imgWidth === -1 && this.imgHeight !== -1) {
                            flag = this.imgWidth === img.height
                        }
                        fn && fn(flag,img)
                    }
                }
            } else {
                fn && fn(true)
            }
        },
        // 文件格式
        getFileType(file){
            return file.raw.type === 'image/png' ? 'png' : (file.raw.type === "application/vnd.android.package-archive" ? 'apk': file.raw.type === 'application/pdf'? 'pdf' :'jpg' )  || "" // 后缀
        }
        // // 注册
        // async registerSrc (hashCode, url, mimeType, name) {
        //   try {
        //     let queryString = `hashCode=${hashCode}&resourceURL=${url}&mimeType=${mimeType}`
        //     if (name) queryString += `&name=${name}`
        //     await api('v2/cms/RegisterDataResource', {
        //       method: 'POST',
        //       noLoading: true,
        //       data: queryString
        //     })
        //   } catch (e) {
        //     console.error(e)
        //   }
        // }
    }
}
</script>

<style lang="scss" scoped>
@import "./index.scss"
</style>


// WEBPACK FOOTER //
// src/components/cmp/uploadFile/index.vue